module.exports = __webpack_public_path__ + "static/media/e2m.dd4b86d7.jpg";